import { trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import { ListingSectionObservable } from '../ListingSection';

import openCancellationPoliciesSimplifiedModal from './CancellationPoliciesSimplifiedModal';

import './CancellationPoliciesSimplified.scss';

const CancellationPoliciesSimplified = () => {
  return (
    <ListingSectionObservable section="cancellationPolicies">
      <ListingTitle role="tertiary">
        {trans('cancellation.policies.title')}
      </ListingTitle>
      <ul className="cancellation-policies-simplified__list">
        <li>
          {trans(
            'listing.simplification.bottom.cancellation.bullet.before-acceptance'
          )}
        </li>
        <li>
          {trans('listing.simplification.bottom.cancellation.bullet.24h-after')}
        </li>
        <li>
          {trans('listing.simplification.bottom.cancellation.bullet.after-24h')}
        </li>
      </ul>
      <Button
        type="button"
        color="link"
        className="cancellation-policies-simplified__learn-more"
        onClick={() =>
          openCancellationPoliciesSimplifiedModal({ fullscreenOnMobile: true })
        }
      >
        {trans('listing.simplification.bottom.cancellation.learn-more')}
      </Button>
    </ListingSectionObservable>
  );
};

export default CancellationPoliciesSimplified;
